
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('circle',{attrs:{"cx":"47.917","cy":"14.617","r":"12.5"}}),_c('path',{attrs:{"d":"M47.917 27.117v43.75m-12.5-19.675l-4.167.925-26.512-7.575a2.083 2.083 0 00-2.655 2.004v41.5c.002.93.619 1.745 1.513 2l27.146 7.758c.334.095.686.105 1.025.03l36.466-8.105a2.08 2.08 0 011.025.034l26.005 7.429a2.083 2.083 0 002.654-2.004v-41.5c0-.931-.618-1.75-1.513-2.005L69.258 43.93a2.083 2.083 0 00-1.025-.033l-7.816 1.742M31.25 52.117v45.766m37.5-54.033v45.767"}})])])
          )
        }
      }
    